/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDownloadDto } from '../../models/document-download-dto';

export interface DocumentsDownloadDocument$Params {
  'x-trace-id'?: string;
  recId: number;
}

export function documentsDownloadDocument(http: HttpClient, rootUrl: string, params: DocumentsDownloadDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDownloadDto>> {
  const rb = new RequestBuilder(rootUrl, documentsDownloadDocument.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('recId', params.recId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDownloadDto>;
    })
  );
}

documentsDownloadDocument.PATH = '/api/documents/{recId}';
